module.exports = __webpack_public_path__ + "static/media/Silverplakett.70786048.png";